import { ProcessingEventProgress } from '@nextforce/api'
import React, { createContext, useContext, useState } from 'react'

interface MessagingContextValue {
  oldMessagesResponseSize: number | undefined
  setOldMessagesResponseSize: React.Dispatch<React.SetStateAction<number>>
  newMessagesResponseSize: number | undefined
  setNewMessagesResponseSize: React.Dispatch<React.SetStateAction<number>>
  progress: ProcessingEventProgress
  setProgress: React.Dispatch<React.SetStateAction<ProcessingEventProgress>>
}

interface Props {
  children: React.ReactNode
}

const MessagingContext = createContext({} as MessagingContextValue)

export function MessagingProvider(props: Props) {
  const [oldMessagesResponseSize, setOldMessagesResponseSize] =
    useState<number>()
  const [newMessagesResponseSize, setNewMessagesResponseSize] =
    useState<number>()
  const [progress, setProgress] = useState<ProcessingEventProgress>({
    current: 0,
    total: 0,
  })

  const value: MessagingContextValue = {
    newMessagesResponseSize,
    setNewMessagesResponseSize,
    oldMessagesResponseSize,
    setOldMessagesResponseSize,
    progress,
    setProgress,
  }
  return (
    <MessagingContext.Provider value={value}>
      {props.children}
    </MessagingContext.Provider>
  )
}

export function useMessagingContext() {
  return useContext<MessagingContextValue>(MessagingContext)
}
